import React, { useEffect, useState } from "react";
import axios from "../utils/axios";
import { message, Modal } from "antd";
import Header from "./header/header2";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

const PLAN_ICONS = ["🌱", "🚀", "💎", "⚡"];

const SubscriptionPage = () => {
  const navigate = useNavigate();
  const organizationId = localStorage.getItem("organizationId");
  const user = JSON.parse(localStorage.getItem("user"));
  const citriot = JSON.parse(localStorage.getItem("citriot")) || {};

  const [plans, setPlans] = useState([]);
  const [activeSub, setActiveSub] = useState(null);
  const [loadingPlanId, setLoadingPlanId] = useState(null);
  const [visible, setVisible] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isRenewal, setIsRenewal] = useState(false);
  const [cameraCount, setCameraCount] = useState(1);

  useEffect(() => {
    fetchPlans();
    fetchUserSubscription();
    setTimeout(() => setVisible(true), 100);
  }, []);

  const fetchPlans = async () => {
    try {
      const res = await axios.post("/get-subscription-plans");
      if (res.data) setPlans(res.data);
    } catch (err) {
      if (err.response && err.response.data) {
        message.warning(err.response.data.msg ? err.response.data.msg : err.response.data);
      } else if (err.response && err.response.status === 401) {
        message.error("User not authorised");
      } else {
        message.error("Something went wrong");
      }
    }
  };

  const fetchUserSubscription = async () => {
    try {
      const res = await axios.post("/get-user-subscription", {
        username: user.username,
        organizationId,
      });
      if (res.data) setActiveSub(res.data);
    } catch (err) {
      if (err.response && err.response.data) {
        message.warning(err.response.data.msg ? err.response.data.msg : err.response.data);
      } else if (err.response && err.response.status === 401) {
        message.error("User not authorised");
      } else {
        message.error("Something went wrong");
      }
    }
  };

  const subscribe = async (planId, isRenewal = false) => {
    setLoadingPlanId(planId);
    try {
      await axios.post("/save-user-subscription", {
        username: user.username,
        planId,
        organizationId,
        isRenewal,
        cameraCount,
      });
      message.success(isRenewal ? "Plan renewed successfully" : "Subscription successful");
      const updatedUser = { ...user, subscribe: true };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      fetchUserSubscription();
      setLoadingPlanId(null);
    } catch (err) {
      setLoadingPlanId(null);
      if (err.response && err.response.data) {
        message.warning(err.response.data.msg ? err.response.data.msg : err.response.data);
      } else if (err.response && err.response.status === 401) {
        message.error("User not authorised");
      } else {
        message.error("Something went wrong");
      }
    }
  };

  const isActivePlan = (planId) => activeSub?.planId?.toString() === planId?.toString();

  // Returns price display for plan cards
  const getPriceDisplay = (plan) => {
    if (plan.isCustom) {
      return { label: "Custom", sublabel: "Negotiated annually", isCustom: true };
    }
    return { label: `Rs.${plan.pricePerCamera}`, sublabel: "/ camera / month", isCustom: false };
  };

  // Sample cost row inside the price box
  const getSampleCostRow = (plan) => {
    if (plan.isCustom) {
      return { left: `Est.`, right: `${plan.priceRange.min}-${plan.priceRange.max}/camera/mon` };
    }
    const cams = plan.recommendedCameras;
    if (!cams) return null;
    return { left: `${cams} cams →`, right: `Rs.${(cams * plan.pricePerCamera).toLocaleString()}/mo` };
  };

  // Active subscription — price per camera display
  const getActivePricePerCamDisplay = (sub) => {
    if (sub.isCustom || sub.pricePerCamera === 0) return { label: "Negotiated", sublabel: "" };
    return { label: `Rs.${sub.pricePerCamera}`, sublabel: "/mo" };
  };

  // Active subscription — total monthly display
  const getActiveSubTotalDisplay = (sub) => {
    if (sub.isCustom || sub.pricePerCamera === 0) {
      return { label: "Custom", sublabel: "Annual contract" };
    }
    return { label: `Rs.${(sub.cameras * sub.pricePerCamera).toLocaleString()}`, sublabel: "/mo" };
  };

  const openConfirmModal = (plan, renewal = false) => {
    setSelectedPlan(plan);
    setIsRenewal(renewal);
    setCameraCount(plan?.cameraRange?.min || 1);
    setConfirmModal(true);
  };

  const closeConfirmModal = () => {
    setConfirmModal(false);
    setSelectedPlan(null);
    setIsRenewal(false);
  };

  const handleConfirmSubscription = () => {
    if (!selectedPlan) return;

    subscribe(selectedPlan._id, isRenewal);
    closeConfirmModal();
  };

  const startDate = new Date();

  const endDate = new Date();
  endDate.setMonth(endDate.getMonth() + 1);

  const formatDate = (d) =>
    d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });

  const totalAmount =
    selectedPlan && !selectedPlan.isCustom
    ? cameraCount * selectedPlan.pricePerCamera
    : null;

  return (
    <div className="min-h-screen bg-slate-50 font-sans">
      <Header auth={citriot?.auth} />

      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 pb-24">
        <div className="flex items-center gap-3 mb-8">
  <button
  onClick={() => navigate(-1)}
  className="w-8 h-8 flex items-center justify-center rounded-lg border border-slate-200 hover:bg-slate-100 text-slate-700 transition"
>
  <ArrowLeftOutlined />
</button>

  <span className="text-sm text-slate-500">Back</span>
</div>

        {activeSub && (
          <div
            className={`relative overflow-hidden rounded-3xl mb-12 transition-all duration-700 max-w-6xl mx-auto ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4"
            }`}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-slate-800 via-slate-700 to-slate-600" />
            <div className="absolute -top-16 -right-16 w-64 h-64 bg-slate-500 opacity-20 rounded-full" />
            <div className="absolute -bottom-12 -left-12 w-48 h-48 bg-slate-500 opacity-20 rounded-full" />

            <div className="relative z-10 p-6 sm:p-6">
              <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-6">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-white bg-opacity-10 rounded-2xl flex items-center justify-center text-2xl flex-shrink-0">
                    🔐
                  </div>
                  <div>
                    <span className="inline-block bg-emerald-500 bg-opacity-20 text-emerald-300 text-xs font-bold tracking-widest uppercase px-2.5 py-1 rounded-full mb-1">
                      ● Active
                    </span>
                    <h2 className="text-2xl font-bold text-white">{activeSub.planName}</h2>
                    <p className="text-slate-300 text-sm">Your current subscription plan</p>
                  </div>
                </div>

                <button
                  onClick={() => openConfirmModal(activeSub, true)}
                  disabled={loadingPlanId === activeSub.planId}
                  className="self-start flex items-center gap-2 bg-white text-slate-700 text-sm font-semibold px-5 py-2.5 rounded-xl hover:bg-slate-100 transition-all duration-200 disabled:opacity-60 shadow-md"
                >
                  {loadingPlanId === activeSub.planId ? (
                    <>
                      <span className="w-4 h-4 border-2 border-slate-300 border-t-slate-600 rounded-full animate-spin" />
                      Renewing...
                    </>
                  ) : (
                    <>Renew Plan</>
                  )}
                </button>
              </div>

              <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-3">
                <div className="bg-white bg-opacity-10 rounded-2xl px-4 py-3.5">
                  <p className="text-slate-300 text-xs font-medium mb-1">Cameras Active</p>
                  <div className="flex items-end gap-2">
                    <span className="text-2xl font-bold text-white">{activeSub.cameras}</span>
                    <span className="text-slate-400 text-sm pb-0.5">cameras</span>
                  </div>
                </div>
                <div className="bg-white bg-opacity-10 rounded-2xl px-4 py-3.5">
                  <p className="text-slate-300 text-xs font-medium mb-1">Price per Camera</p>
                  <div className="flex items-end gap-1">
                    <span className="text-2xl font-bold text-white">{getActivePricePerCamDisplay(activeSub).label}</span>
                    {getActivePricePerCamDisplay(activeSub).sublabel && (
                      <span className="text-slate-400 text-sm pb-0.5">{getActivePricePerCamDisplay(activeSub).sublabel}</span>
                    )}
                  </div>
                </div>
                <div className="bg-white bg-opacity-10 rounded-2xl px-4 py-3.5 col-span-2 sm:col-span-1">
                  <p className="text-slate-300 text-xs font-medium mb-1">Monthly Total</p>
                  <div className="flex items-end gap-1">
                    <span className="text-2xl font-bold text-white">{getActiveSubTotalDisplay(activeSub).label}</span>
                    {getActiveSubTotalDisplay(activeSub).sublabel && (
                      <span className="text-slate-400 text-sm pb-0.5">{getActiveSubTotalDisplay(activeSub).sublabel}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div
          className={`text-center mb-10 transition-all duration-700 delay-100 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          {activeSub ? (
            <>
              <p className="text-slate-500 text-sm font-semibold uppercase tracking-widest mb-2">Manage Subscription</p>
              <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-800 tracking-tight">
                Switch or upgrade your plan
              </h1>
              <p className="text-slate-400 mt-2 text-base max-w-md mx-auto">
                Change plans anytime. Your new plan activates immediately.
              </p>
            </>
          ) : (
            <>
              <p className="text-slate-500 text-sm font-semibold uppercase tracking-widest mb-2">Flexible Pricing</p>
              <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-800 tracking-tight">
                Choose the right plan for you
              </h1>
              <p className="text-slate-400 mt-2 text-base max-w-md mx-auto">
                Scale your security infrastructure with transparent, per-camera pricing.
              </p>
            </>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {plans.length === 0
            ? [1, 2, 3, 4].map((i) => (
                <div key={i} className="bg-white rounded-2xl border border-slate-200 p-6 flex flex-col gap-4 animate-pulse">
                  <div className="w-11 h-11 bg-slate-100 rounded-xl" />
                  <div className="h-5 bg-slate-100 rounded w-3/5" />
                  <div className="h-4 bg-slate-100 rounded w-2/5" />
                  <div className="h-10 bg-slate-100 rounded w-1/2 mt-1" />
                  <div className="h-px bg-slate-100 w-full" />
                  {[1, 2, 3, 4].map((j) => (
                    <div key={j} className="h-3 bg-slate-100 rounded" style={{ width: `${50 + j * 15}%` }} />
                  ))}
                  <div className="h-11 bg-slate-100 rounded-xl mt-auto" />
                </div>
              ))
            : plans.map((plan, idx) => {
                const isActive = isActivePlan(plan._id);
                const isPopular = plan.isPopular;
                const isCustom = plan.isCustom;
                const isLoading = loadingPlanId === plan._id;

                return (
                  <div
                    key={plan._id}
                    className={`
                      relative flex flex-col rounded-2xl p-6 border transition-all duration-500
                      ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
                      ${isActive
                        ? "bg-slate-100 border-slate-300 ring-2 ring-slate-300 shadow-lg"
                        : isPopular
                        ? "bg-slate-800 border-slate-600 ring-1 ring-slate-500 shadow-lg hover:-translate-y-1"
                        : "bg-white border-slate-200 hover:-translate-y-1 hover:shadow-md hover:border-slate-300"
                      }
                    `}
                    style={{ transitionDelay: `${(idx + 1) * 80}ms` }}
                  >
                    {/* Subtle top accent bar for popular card */}
                    {isPopular && !isActive && (
                      <div className="absolute top-0 left-6 right-6 h-0.5 bg-gradient-to-r from-slate-400 via-slate-500 to-slate-400 rounded-b-full" />
                    )}

                    {isActive && (
                      <div className={`absolute top-0 left-6 right-6 rounded-b-full ${isPopular ? "h-1 bg-gradient-to-r from-emerald-500 via-slate-500 to-slate-400" : "h-1 bg-gradient-to-r from-slate-600 to-slate-400"}`} />
                    )}

                    <div className="flex items-center justify-between mb-5">
                      <div
                        className={`w-11 h-11 rounded-xl flex items-center justify-center text-xl
                          ${isActive ? "bg-slate-200" : isPopular ? "bg-slate-700" : "bg-slate-100"}
                        `}
                      >
                        {PLAN_ICONS[idx] || "📦"}
                      </div>
                      <div className="flex flex-col gap-1 items-end">
                        {isActive && (
                          <span className="bg-slate-700 text-white text-xs font-bold tracking-wide uppercase px-2.5 py-1 rounded-full">
                            Current Plan
                          </span>
                        )}
                        {isPopular && (
                          <span className={`text-xs font-bold tracking-wide uppercase px-2.5 py-1 rounded-full ${isActive ? "bg-emerald-100 text-emerald-700" : "bg-slate-600 text-white"}`}>
                            ★ Popular
                          </span>
                        )}
                      </div>
                    </div>

                    <h2 className={`text-lg font-bold mb-0.5 ${isPopular && !isActive ? "text-white" : "text-slate-800"}`}>
                      {plan.name}
                    </h2>
                    { !isCustom && <p className={`text-xs mb-5 ${isPopular && !isActive ? "text-slate-400" : "text-slate-400"}`}>
                      {plan.cameraRange?.min}-{plan.cameraRange?.max} cameras supported
                    </p>}

                    { isCustom && <p className={`text-xs mb-5 ${isPopular && !isActive ? "text-slate-400" : "text-slate-400"}`}>
                      {plan.cameraRange?.min}+ cameras supported
                    </p>}

                    <div
                      className={`rounded-xl px-4 py-3 mb-5
                        ${isActive ? "bg-slate-200" : isPopular ? "bg-slate-700" : "bg-slate-50"}
                      `}
                    >
                      {(() => {
                        const price = getPriceDisplay(plan);
                        const sampleRow = getSampleCostRow(plan);
                        return (
                          <>
                            <div className="flex items-baseline gap-1">
                              <span className={`text-3xl font-bold tracking-tight ${isPopular && !isActive ? "text-white" : "text-slate-800"}`}>
                                {price.label}
                              </span>
                              <span className={`text-sm ${isPopular && !isActive ? "text-slate-400" : "text-slate-400"}`}>
                                {price.sublabel}
                              </span>

                            </div>
                            {sampleRow && (
                              <div className={`mt-3 rounded-md px-3 py-2 text-sm flex justify-between items-center ${isPopular && !isActive ? "bg-slate-600 text-slate-200" : "bg-slate-200 text-slate-700"}`}>
                                <span>{sampleRow.left}</span>
                                <span className="font-semibold">{sampleRow.right}</span>
                              </div>
                            )}
                          </>
                        );
                      })()}
                    </div>

                    <div className={`h-px w-full mb-5 ${isPopular && !isActive ? "bg-slate-600" : "bg-slate-200"}`} />

                    <ul className="flex flex-col gap-2.5 mb-6 flex-1">
                      {plan.features.map((feature, fi) => (
                        <li
                          key={fi}
                          className={`flex items-start gap-2.5 text-sm leading-relaxed ${isPopular && !isActive ? "text-slate-300" : "text-slate-600"}`}
                        >
                          <span className={`mt-0.5 w-4 h-4 rounded flex items-center justify-center text-xs font-bold flex-shrink-0 ${isPopular && !isActive ? "bg-slate-600 text-slate-300" : "bg-slate-200 text-slate-600"}`}>
                            v
                          </span>
                          {feature}
                        </li>
                      ))}
                    </ul>

                    {isActive ? (
                      <button
                        onClick={() => openConfirmModal(plan, true)}
                        disabled={isLoading}
                        className="w-full py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 bg-slate-700 text-white hover:bg-slate-800 shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-60 disabled:pointer-events-none"
                      >
                        {isLoading ? (
                          <>
                            <span className="w-4 h-4 border-2 border-white border-opacity-30 border-t-white rounded-full animate-spin" />
                            Renewing...
                          </>
                        ) : (
                          <>Renew {plan.name}</>
                        )}
                      </button>
                    ) : (
                      <button
                        onClick={() => openConfirmModal(plan, false)}
                        disabled={isLoading}
                        className={`w-full py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 shadow hover:shadow-md transition-all duration-200 disabled:opacity-60 disabled:pointer-events-none
                          ${isPopular && !isActive
                            ? "bg-white text-slate-800 hover:bg-slate-100"
                            : "bg-slate-700 text-white hover:bg-slate-800"
                          }`}
                      >
                        {isLoading ? (
                          <>
                            <span className="w-4 h-4 border-2 border-white border-opacity-30 border-t-white rounded-full animate-spin" />
                            Processing...
                          </>
                        ) : activeSub ? (
                          <>Switch to {plan.name}</>
                        ) : (
                          <>Get {plan.name}</>
                        )}
                      </button>
                    )}
                  </div>
                );
              })}
        </div>

        <div
          className={`flex items-center justify-center flex-wrap gap-6 mt-14 pt-8 border-t border-slate-200 transition-all duration-700 delay-500 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          {[
            { icon: "🔒", label: "Secure payments" },
            { icon: "↩️", label: "Cancel anytime" },
            { icon: "⚡", label: "Instant activation" },
            { icon: "🎧", label: "24/7 support" },
          ].map((t) => (
            <div key={t.label} className="flex items-center gap-2 text-slate-400 text-sm font-medium">
              <span>{t.icon}</span>
              {t.label}
            </div>
          ))}
        </div>
      </div>
      <Modal
  open={confirmModal}
  footer={null}
  centered
  width={430}
  closable={false}
  onCancel={closeConfirmModal}
>
  <div className="p-4">

    {/* Icon */}
    <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-slate-100 flex items-center justify-center text-2xl">
      💳
    </div>

    <h2 className="text-xl font-bold text-slate-800 text-center mb-1">
      {isRenewal ? "Renew Subscription" : "Confirm Subscription"}
    </h2>

    <p className="text-slate-500 text-sm text-center mb-6">
      Review your subscription details
    </p>

    {selectedPlan && (
      <>
        {/* Plan */}
        <div className="bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 mb-4">
          <p className="text-xs text-slate-500 mb-1">Plan</p>
          <p className="text-lg font-semibold text-slate-800">
            {isRenewal ? selectedPlan.planName : selectedPlan.name}
          </p>
        </div>

        {/* Camera Range */}
        <div className="mb-4">
          <p className="text-xs text-slate-500 mb-1">Supported Cameras</p>
          <p className="text-sm font-medium text-slate-700">
            {selectedPlan.isCustom
              ? `${selectedPlan.cameraRange?.min}+ cameras`
              : `${selectedPlan.cameraRange?.min} - ${selectedPlan.cameraRange?.max} cameras`}
          </p>
        </div>

        {/* Camera Input */}
        {!selectedPlan.isCustom && (
          <div className="mb-4">
            <p className="text-xs text-slate-500 mb-1">Number of Cameras</p>

            <input
              type="number"
              min={selectedPlan.cameraRange?.min}
              max={selectedPlan.cameraRange?.max}
              value={cameraCount}
              onChange={(e) => setCameraCount(Number(e.target.value))}
              className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-300"
            />
          </div>
        )}

        {/* Price Info */}
        <div className="bg-slate-100 rounded-xl p-4 mb-6 space-y-2 text-sm">

          {!selectedPlan.isCustom && (
            <div className="flex justify-between">
              <span className="text-slate-500">Price / Camera</span>
              <span className="font-semibold text-slate-700">
                ₹{selectedPlan.pricePerCamera}
              </span>
            </div>
          )}

          <div className="flex justify-between">
            <span className="text-slate-500">Start Date</span>
            <span className="text-slate-700">{formatDate(startDate)}</span>
          </div>

          <div className="flex justify-between">
            <span className="text-slate-500">End Date</span>
            <span className="text-slate-700">{formatDate(endDate)}</span>
          </div>

          {!selectedPlan.isCustom && (
            <div className="border-t border-slate-300 pt-2 flex justify-between font-semibold text-base">
              <span>Total</span>
              <span>₹{totalAmount?.toLocaleString()}</span>
            </div>
          )}

          {selectedPlan.isCustom && (
            <div className="border-t border-slate-300 pt-2 flex justify-between font-semibold">
              <span>Total</span>
              <span>Custom Pricing</span>
            </div>
          )}
        </div>
      </>
    )}

    {/* Buttons */}
    <div className="flex gap-3">
      <button
        onClick={closeConfirmModal}
        className="flex-1 py-2.5 rounded-xl border border-slate-200 text-slate-600 font-medium hover:bg-slate-100 transition"
      >
        Cancel
      </button>

      <button
        onClick={handleConfirmSubscription}
        className="flex-1 py-2.5 rounded-xl bg-slate-700 text-white font-semibold hover:bg-slate-800 transition"
      >
        {isRenewal ? "Renew Plan" : "Confirm Purchase"}
      </button>
    </div>
  </div>
</Modal>
    </div>
  );
};

export default SubscriptionPage;